import {css} from "lit";
import {customScrollStyles} from "../styles/CustomScrollBar.js";

export const dropdownStyles = [customScrollStyles, css`
	/* Dropdown Menus */
	.dropup, .dropdown {
		position: relative;
	}

	.dropdown.open > .dropdown-menu,
	.dropup.open > .dropdown-menu {
		display: block;
	}

	.dropdown *, .dropup * {
		box-sizing: border-box;
	}

	.btn-dropdown {
		font-size: calc(var(--pn-font-size-large) + 3px);
		line-height: inherit;
	}

	.btn-dropdown[icon="three-dots"] {
		display: block;
		transform: rotate(90deg);
	}

	.dropdown-menu {
		margin: 0 0 3px 0;
		padding: 6px 0;
		min-width: auto;
		position: absolute;
		top: 100%;
		left: 0;
		z-index: var(--pn-dropdown-zindex);
		display: none; // none by default, but block on "open" of the menu
		float: left;
		text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)

		border: 1px solid @dropdown-border;
		background-clip: padding-box;

		background-color: var(--pn-dropdown-item-bg-color);
		border-radius: calc(var(--pn-border-radius-small) + 1px);
		box-shadow: 0 0 7px 0 var(--pn-dropdown-shadow-color);
		width: 140px;
		font-size: var(--pn-font-size-base);
		/* .custom-scroll-bar(); */
	}

	.dropdown-menu.auto-width {
		width: auto;
	}

	.dropdown-menu.dropdown-menu-projects {
		width: 200px;
		position: static;
	}

	.dropdown-right-aligned .dropdown-menu {
		left: auto;
		right: 0;
	}
`];
